// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

export const modalStyles = css`
    background-color: #082145;
    color: #fff;
    padding: 32px 24px;
    position: relative;

    h2 {
        color: #fff;
        font-weight: 600;
    }
`;

export const closeModalButtonStyles = css`
    position: absolute;
    top: 16px;
    right: 16px;
    height: 24px;
    width: 24px;
`;

export const imageStyles = css`
    margin: 0 auto 24px;
    width: 207px;

    img {
        display: block;
        height: auto;
        max-width: 100%;
    }
`;

export const descriptionStyles = css`
    font-size: 16px;
    line-height: 1.5;
    margin-top: 12px;
    margin-bottom: 32px;
`;

export const ctaButtonStyles = css`
    font-size: 14px;
`;
